import { render, staticRenderFns } from "./service-detail-modele-aim.vue?vue&type=template&id=6aa9dc59&scoped=true"
import script from "./service-detail-modele-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./service-detail-modele-aim.vue?vue&type=script&setup=true&lang=js"
import style0 from "./service-detail-modele-aim.vue?vue&type=style&index=0&id=6aa9dc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9dc59",
  null
  
)

export default component.exports